import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminLanguage } from '../AdminLanguageContext';
import api from '../api';
import './Login.css';

const showDefaultLoginHint = process.env.NODE_ENV !== 'production'
  && process.env.REACT_APP_SHOW_ADMIN_DEFAULT_LOGIN_HINT === 'true';
const defaultAdminEmail = process.env.REACT_APP_DEFAULT_ADMIN_EMAIL || 'admin@skill-platform.com';

export default function Login() {
  const navigate = useNavigate();
  const { copy } = useAdminLanguage();
  const loginCopy = copy.login;
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/users/login', form);
      if (res.data.user?.role !== 'admin') {
        setError(loginCopy.noAdminPermission);
        return;
      }
      localStorage.setItem('admin_token', res.data.token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || loginCopy.failed);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <span>S</span>
        </div>
        <h2>{loginCopy.title}</h2>
        <p>{loginCopy.subtitle}</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{loginCopy.email}</label>
            <input
              type="email"
              value={form.email}
              onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              placeholder="admin@skill-platform.com"
            />
          </div>
          <div className="form-group">
            <label>{loginCopy.password}</label>
            <input
              type="password"
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              placeholder={loginCopy.passwordPlaceholder}
            />
          </div>
          {error && <p className="error-msg">{error}</p>}
          <button type="submit" className="btn btn-primary login-btn" disabled={loading}>
            {loading ? loginCopy.loading : loginCopy.login}
          </button>
        </form>
        {showDefaultLoginHint && (
          <div className="login-hint">
            {loginCopy.localDefaultEmail}: {defaultAdminEmail}
          </div>
        )}
      </div>
    </div>
  );
}
